/**
 * @fileoverview Protected Route Component
 * @module ProtectedRoute
 * 
 * Business Context:
 * - Protects authenticated routes from unauthorized access
 * - Provides seamless redirects for unauthenticated users
 * - Shows loading states during authentication checks
 * 
 * Technical Context:
 * - Uses React Router for navigation
 * - Integrates with AuthContext for authentication state
 * - Handles authentication loading states gracefully
 * 
 * NOTE: TEMPORARILY DISABLED FOR DEVELOPMENT/DEMO
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to auth page if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // Render protected content
  return <>{children}</>;
}; 